import { FC } from 'react';
import styles from './index.less';
import successUrl from '@/assets/bindHouse/success_result.png';
import loseUrl from '@/assets/bindHouse/lose_result.png';

interface IBindResultProps {
  result: 'success' | 'lose';
}

const BindResult: FC<IBindResultProps> = (props) => {
  const { result } = props;
  return (
    <div className={styles.container}>
      <img src={result === 'success' ? successUrl : loseUrl} alt={result} />
      {result === 'lose' ? (
        <>
          <p>房间绑定失败</p>
          <span>未查询到该业主信息</span>
        </>
      ) : (
        <p>房间绑定成功</p>
      )}
    </div>
  );
};
export default BindResult;
